import { render, staticRenderFns } from "./EditBtn.vue?vue&type=template&id=6fbb2448&"
import script from "./EditBtn.vue?vue&type=script&lang=js&"
export * from "./EditBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports